import {LinkType} from "../../modules/enums";
import {IPolicyLink} from "../../modules/components";

const PolicyLinks = ({link}: {link: IPolicyLink}) => (
  <a href={link.type === LinkType.EMAIL ? `mailto${link.href}` : link.href}>
    {link.href}
  </a>
)
export default PolicyLinks;
